import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "waiting" }, [
  /*#__PURE__*/_createElementVNode("svg", null, [
    /*#__PURE__*/_createElementVNode("use", { href: "#animation-waiting" })
  ])
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "invisible-waiting-screen"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["waiting-screen", { active: _ctx.dialogs.waiting }])
    }, _hoisted_2, 2),
    (_ctx.dialogs.waitingInvisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}